var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Header'),_c('v-main',[_c('router-view',{staticClass:"body-top"}),_c('ToTopButton',{attrs:{"path":_vm.path}})],1),_c('Footer',{attrs:{"path":_vm.path}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }